import * as React from "react"

import {
  EPL_ACCOUNTS_GET_SUCCESS,
  EPL_ADRATE_CAMPAIGN_STRATEGY_UPDATE_SUCCESS,
  EPL_AD_RATE_SUCCESS_NOTIFICATION_CLEAR,
  EPL_CREATE_ZENDESK_CHURN_TICKET_SUCCESS,
  EPL_CREATE_ZENDESK_CHURN_TICKET_SUCCESS_NOTIFICATION_CLEAR,
  EPL_END_OWN_CAMPAIGNS_ALERT,
  EPL_EXCLUDE_ITEMS_BY_FILE_SUCCESS_NOTIFICATION_CLEAR,
  EPL_ITEMS_EXCLUDED_RESET_ALL_SUCCESS,
  EPL_ITEMS_EXCLUDED_RESET_ALL_SUCCESS_NOTIFICATION_CLEAR,
  EPL_ITEMS_EXCLUDED_RESET_SELECTED_SUCCESS,
  EPL_ITEMS_EXCLUDED_RESET_SELECTED_SUCCESS_NOTIFICATION_CLEAR,
  EPL_ITEMS_EXCLUDE_BY_FILE_SUCCESS,
  EPL_ITEMS_EXCLUDE_SELECTED_SUCCESS,
  EPL_ITEMS_EXCLUDE_SELECTED_SUCCESS_NOTIFICATION_CLEAR,
  EPL_ITEMS_STATUS_GET_WITH_RESULTS,
  EPL_ITEMS_STATUS_GET_WITH_RESULTS_NOTIFICATION_CLEAR,
  EPL_LOCAL_DATA,
  EPL_MARKETS_CLOSE_SUCCESS,
  EPL_MARKETS_OPEN_SUCCESS,
  EPL_MARKETS_PAUSE_SUCCESS,
  EPL_MARKETS_RESUME_SUCCESS,
  EPL_MARKET_CLOSE_SUCCESS_NOTIFICATION_CLEAR,
  EPL_MARKET_OPEN_SUCCESS_NOTIFICATION_CLEAR,
  EPL_MARKET_PAUSE_SUCCESS_NOTIFICATION_CLEAR,
  EPL_MARKET_RESUME_SUCCESS_NOTIFICATION_CLEAR,
  EPL_OPT_OUT_POST_SUCCESS,
  EPL_OPT_OUT_POST_SUCCESS_NOTIFICATION_CLEAR,
  EPL_PLAN_PLA_DOMESTIC_UPGRADE_SUCCESS,
  EPL_PLAN_PLA_INTERNATIONAL_UPGRADE_SUCCESS,
  EPL_PLAN_PLS_DOMESTIC_UPGRADE_SUCCESS,
  EPL_PLAN_PLS_INTERNATIONAL_UPGRADE_SUCCESS,
  EPL_PLAN_UPGRADE_SUCCESS_NOTIFICATION_CLEAR,
  EPL_SET_AD_RATE_FOR_MARKET_POST_SUCCESS,
  EPL_SET_AD_RATE_FOR_MARKET_POST_SUCCESS_NOTIFICATION_CLEAR,
  EPL_SET_BUDGET_FOR_ORIGIN_POST_SUCCESS,
  EPL_SET_BUDGET_FOR_ORIGIN_POST_SUCCESS_NOTIFICATION_CLEAR,
  EPL_START_POST_SUCCESS_NOTIFICATION_CLEAR,
  EPL_START_SUCCESS,
  EPL_UNACCEPTED_TOS_ALERT,
  EPL_UNACCEPTED_TOS_WARNING,
  EPL_UPSELL_START_SUCCESS,
  NO_MARKETS_ON_ACTIVE_SERVICE_ALERT,
  NO_MARKETS_ON_ACTIVE_SERVICE_ALERT_CLEAR,
  EPL_NO_ACTIVATION_ALERT,
  EPL_NO_ACTIVATION_ALERT_CLEAR,
} from "data/constants"
import { DataStore } from "shared/helpers/localStorage"

const { EPL_LOCAL_STORAGE, SHOW_END_OWN_CAMPAIGNS_ALERT } = EPL_LOCAL_DATA
const eplLocalStorage = DataStore.getAll(EPL_LOCAL_STORAGE)

const EplAlertsContext = React.createContext()

function eplAlertsReducer(state, action) {
  switch (action.type) {
    case EPL_ADRATE_CAMPAIGN_STRATEGY_UPDATE_SUCCESS:
      return {
        ...state,
        lastUpdatedCampaign: {
          status: { status: true, data: action.data.campaignName },
        },
      }
    case EPL_AD_RATE_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        lastUpdatedCampaign: { status: false },
      }
    case EPL_PLAN_PLS_INTERNATIONAL_UPGRADE_SUCCESS:
    case EPL_PLAN_PLS_DOMESTIC_UPGRADE_SUCCESS:
    case EPL_PLAN_PLA_INTERNATIONAL_UPGRADE_SUCCESS:
    case EPL_PLAN_PLA_DOMESTIC_UPGRADE_SUCCESS:
      return {
        ...state,
        showPlanUpgradeAlert: { status: true },
      }
    case EPL_PLAN_UPGRADE_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showPlanUpgradeAlert: { status: false },
      }
    case EPL_MARKETS_PAUSE_SUCCESS:
      return {
        ...state,
        showMarketPauseSuccessAlert: { status: true },
      }
    case EPL_MARKET_PAUSE_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showMarketPauseSuccessAlert: { status: false },
      }
    case EPL_MARKETS_CLOSE_SUCCESS:
      return {
        ...state,
        showMarketCloseSuccessAlert: { status: true },
      }

    case EPL_MARKET_CLOSE_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showMarketCloseSuccessAlert: { status: false },
      }
    case EPL_MARKETS_RESUME_SUCCESS:
      return {
        ...state,
        showMarketResumeSuccessAlert: { status: true },
      }
    case EPL_MARKET_RESUME_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showMarketResumeSuccessAlert: { status: false },
      }
    case EPL_MARKETS_OPEN_SUCCESS:
      return {
        ...state,
        showMarketOpenSuccessAlert: { status: true },
      }
    case EPL_MARKET_OPEN_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showMarketOpenSuccessAlert: { status: false },
      }
    case EPL_CREATE_ZENDESK_CHURN_TICKET_SUCCESS:
      return {
        ...state,
        showCreateChurnTicketSuccessAlert: { status: true },
      }
    case EPL_CREATE_ZENDESK_CHURN_TICKET_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showCreateChurnTicketSuccessAlert: { status: false },
      }
    case EPL_OPT_OUT_POST_SUCCESS:
      return {
        ...state,
        showOptOutSuccessAlert: { status: true },
      }
    case EPL_OPT_OUT_POST_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showOptOutSuccessAlert: { status: false },
      }
    case EPL_ITEMS_EXCLUDE_BY_FILE_SUCCESS:
      return {
        ...state,
        showItemsExcludeByFileSuccessAlert: { status: true },
      }
    case EPL_EXCLUDE_ITEMS_BY_FILE_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showItemsExcludeByFileSuccessAlert: { status: false },
      }
    case EPL_ITEMS_EXCLUDED_RESET_ALL_SUCCESS:
      return {
        ...state,
        showItemsDeleteAllExclusionsSuccessAlert: { status: true },
      }
    case EPL_ITEMS_EXCLUDED_RESET_ALL_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showItemsDeleteAllExclusionsSuccessAlert: { status: false },
      }
    case EPL_ITEMS_EXCLUDED_RESET_SELECTED_SUCCESS:
      return {
        ...state,
        showItemsDeleteSelectedExclusionsSuccessAlert: {
          status: true,
          data: {
            lastDeletedExclusions: action.data.affected,
          },
        },
      }
    case EPL_ITEMS_EXCLUDED_RESET_SELECTED_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showItemsDeleteSelectedExclusionsSuccessAlert: {
          status: false,
          data: { lastDeletedExclusions: 0 },
        },
      }
    case EPL_ITEMS_EXCLUDE_SELECTED_SUCCESS:
      return {
        ...state,
        showItemsExcludeSelectedSuccessAlert: {
          status: true,
          data: {
            lastExcludedItems: action.data.affected,
          },
        },
      }
    case EPL_ITEMS_EXCLUDE_SELECTED_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showItemsExcludeSelectedSuccessAlert: {
          status: false,
          data: { lastExcludedItems: 0 },
        },
      }
    case EPL_ITEMS_STATUS_GET_WITH_RESULTS:
      return {
        ...state,
        showItemsExcludeByFileResultAlert: {
          status: true,
          data: {
            lastExcludedItemsByFile: action.data.excluded,
            lastFailedItemsByFile: action.data.failed,
          },
        },
      }
    case EPL_ITEMS_STATUS_GET_WITH_RESULTS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showItemsExcludeByFileResultAlert: {
          status: false,
          data: {
            lastExcludedItemsByFile: 0,
            lastFailedItemsByFile: 0,
          },
        },
      }
    case EPL_START_SUCCESS:
    case EPL_UPSELL_START_SUCCESS:
      return {
        ...state,
        showEplStartSuccessAlert: { status: true },
        showDomesticUpsell: { status: false },
      }
    case EPL_START_POST_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showEplStartSuccessAlert: { status: false },
      }
    case EPL_SET_AD_RATE_FOR_MARKET_POST_SUCCESS:
      return {
        ...state,
        showMarketSetAdRateSuccessAlert: { status: true },
      }
    case EPL_SET_AD_RATE_FOR_MARKET_POST_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showMarketSetAdRateSuccessAlert: { status: false },
      }
    case EPL_SET_BUDGET_FOR_ORIGIN_POST_SUCCESS:
      return {
        ...state,
        showOriginSetBudgetSuccessAlert: { status: true },
      }
    case EPL_SET_BUDGET_FOR_ORIGIN_POST_SUCCESS_NOTIFICATION_CLEAR:
      return {
        ...state,
        showOriginSetBudgetSuccessAlert: { status: false },
      }
    case EPL_UNACCEPTED_TOS_ALERT:
      return {
        ...state,
        showUnacceptedToSAlert: { status: true },
      }
    case EPL_END_OWN_CAMPAIGNS_ALERT:
      return {
        ...state,
        showEndOwnCampaignsAlert: { status: false },
      }
    case EPL_UNACCEPTED_TOS_WARNING:
      return {
        ...state,
        showUnacceptedToSWarning: { status: true },
      }
    case EPL_ACCOUNTS_GET_SUCCESS:
      return {
        ...state,
        showDomesticUpsell: getDomesticUpsellStatus(action.data),
      }
    case NO_MARKETS_ON_ACTIVE_SERVICE_ALERT:
      return {
        ...state,
        showNoMarketsOnActiveServiceAlert: { status: true },
      }
    case NO_MARKETS_ON_ACTIVE_SERVICE_ALERT_CLEAR:
      return {
        ...state,
        showNoMarketsOnActiveServiceAlert: { status: false },
      }
    case EPL_NO_ACTIVATION_ALERT:
      return {
        ...state,
        showNoActivation: { status: true },
      }
    case EPL_NO_ACTIVATION_ALERT_CLEAR:
      return {
        ...state,
        showNoActivation: { status: false },
      }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

function EplAlertsContextProvider({ children }) {
  const [state, dispatch] = React.useReducer(eplAlertsReducer, {
    lastUpdatedCampaign: { status: false },
    showPlanUpgradeAlert: { status: false },
    showMarketCloseSuccessAlert: { status: false },
    showMarketOpenSuccessAlert: { status: false },
    showMarketPauseSuccessAlert: { status: false },
    showMarketResumeSuccessAlert: { status: false },
    showMarketSetAdRateSuccessAlert: { status: false },
    showOriginSetBudgetSuccessAlert: { status: false },
    showCreateChurnTicketSuccessAlert: { status: false },
    showOptOutSuccessAlert: { status: false },
    showItemsExcludeByFileSuccessAlert: { status: false },
    showItemsDeleteAllExclusionsSuccessAlert: { status: false },
    showItemsDeleteSelectedExclusionsSuccessAlert: { status: false },
    showItemsExcludeSelectedSuccessAlert: { status: false },
    showItemsExcludeByFileResultAlert: { status: false },
    showEplStartSuccessAlert: { status: false },
    showUnacceptedToSAlert: { status: false },
    showUnacceptedToSWarning: { status: false },
    showDomesticUpsell: { status: false },
    showEndOwnCampaignsAlert: {
      status: checkEndOwnCampaignsStatus(),
    },
    showNoMarketsOnActiveServiceAlert: {
      status: false,
    },
    showNoActivation: { status: false },
  })
  const value = { state, dispatch }
  return (
    <EplAlertsContext.Provider value={value}>
      {children}
    </EplAlertsContext.Provider>
  )
}

function checkEndOwnCampaignsStatus() {
  if (
    eplLocalStorage &&
    eplLocalStorage[SHOW_END_OWN_CAMPAIGNS_ALERT] !== undefined
  )
    return eplLocalStorage[SHOW_END_OWN_CAMPAIGNS_ALERT]
  return true
}

function getDomesticUpsellStatus(data) {
  const activeUser = data?.accounts.find(
    account => account.account_id === data.activeAccount
  )
  return activeUser?.show_upsell_banner.customer
}

function useEplAlertsContext() {
  const context = React.useContext(EplAlertsContext)
  if (context === undefined) {
    throw new Error(
      "useEplAlertsContext must be used within the EplAlertsContextProvider"
    )
  }
  return context
}

export { EplAlertsContextProvider, useEplAlertsContext }
